import { render, staticRenderFns } from "./P0905.vue?vue&type=template&id=7dfb478e&"
import script from "./P0905.vue?vue&type=script&lang=ts&"
export * from "./P0905.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports